import loadable from '@loadable/component';

export const OrgDashboardRepostInternshipPageContainerLoadable = loadable(
  () => import('./OrgDashboardRepostInternshipPageContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardRepostInternshipPageContainer,
  },
);
